import styled from "styled-components";

export const TableWrapper = styled("table")(() => {
  return {
    width: "100%",
    borderSpacing: "0 4px",
    cursor: "pointer",
    "& th": {
      textAlign: "left",
      textTransform: "capitalize",
      padding: "calc(var(--cardPadding)/2)",
      minWidth: "40px",
      fontSize: "16px",
      fontWeight: 600,
      color: "#000000",
      userSelect: "none",
    },
    "& td": {
      textAlign: "left",
      padding: "calc(var(--cardPadding)/2)",
      border: "none",
      minWidth: "40px",
      color: "#222222",
    },
    "& td.view-payslip-link": {
      color: "var(--color-primary)",
      textDecoration: "none",
      cursor: "pointer",
    },
    "& td.view-payslip-link:hover": {
      textDecoration: "underline",
    },
    "& tbody tr td:nth-child(1)": {
      textAlign: "left",
    },
    "& .employee-cell": {
      display: "flex",
      alignItems: "center",
      gap: "0.75rem",
    },
    "& .employee-cell img": {
      width: "38px",
      height: "38px",
      borderRadius: "50%",
      objectFit: "cover",
      border: "1px solid #ddd",
    },
    "& .employee-text": {
      display: "flex",
      flexDirection: "column",
      gap: "0.18rem",
    },
    "& .employee-name": {
      fontWeight: 600,
      color: "#222222",
      fontSize: "0.95rem",
      lineHeight: 1.2,
    },
    "& .employee-role": {
      color: "#666666",
      fontSize: "0.82rem",
      lineHeight: 1.2,
    },
    "& .plans-pricing-actions": {
      display: "flex",
      gap: "0.75rem",
    },
    "& .plans-pricing-actions button": {
      border: "none",
      background: "transparent",
      color: "var(--color-primary)",
      cursor: "pointer",
      padding: 0,
      font: "inherit",
      textDecoration: "underline",
    },
    "& tbody tr:hover": {
      background: "rgba(0, 0, 0, 0.02)",
    },
    "& .table-total-row": {
      fontWeight: 600,
      borderTop: "1px solid #dddddd",
    },
    "& .table-total-row td": {
      fontWeight: 700,
    },
  };
});
